<meta name="viewport" content="width=device-width, initial-scale=1">
<po-page-default>
  <app-contexttoolbar></app-contexttoolbar>
  <div class="cp-cockpitpage">
    <br />
    <app-contextproject></app-contextproject>

    <div class="po-row cp-margin-top-content">
      <h1 class="po-font-title">{{literalsCp?.strQueProcura}}</h1>
      <div class="cp-buttons-align-responsive">
        <button #buttonTask class="cp-button-selected" value="0"
          (click)="onClickBtnEvent($event)">{{literalsCp?.strTarefa}}</button>
        <button #buttonInput class="buttonUnSelected" value="1"
          (click)="onClickBtnEvent($event)">{{literalsCp?.strInsumo}}</button>
      </div>
    </div>
    <div class="cursor"> <po-button 
      id="id-btn-refresh"
      p-small="boolean"
      p-label="{{literalsCp?.strAtualizar}}"
      p-icon="po-icon po-icon-refresh" (click)="onClickRefresh($event)">
 </po-button></div>
    <br />

    <div [hidden]="IsTask">
      <cp-task-board #taskBoard></cp-task-board>
    </div>

    <div [hidden]="!IsTask">
      <cp-input-board #inputBoard></cp-input-board>
    </div>

  </div>
</po-page-default>
